module.exports = __webpack_public_path__ + "img/tg.b40b5851.svg";